import { useNavigate } from "react-router";
import StatusTag from "../../common/StatusTag";
import ServiceIcon from "../../common/serviceTypeImage";
import { Button } from "react-bootstrap";
import DateHelper from "../../../utils/DateHelper";
import { GetImages } from "../../../utils/GetImages";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";

const CardView = (data) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        key={`${data.item.id}`}
        className="propertyCardConatiner"
        onClick={() => navigate(`/servicerequest/edit/${data.item?.id}`)}
      >
        <div className="propertCardLeft" style={{ maxWidth: "43%" }}>
          <div className="imgcommonstyle">
            <ServiceIcon serviceType={data.item?.formatted?.ServiceType} />
          </div>

          <div className="propertyCardDisc">
            <div className="propertyCardDetails ">
              <div className="d-flex align-items-center ">
                <span className="sub_text grey_subtext1">
                  {data.item?.formatted.ServiceSubType}
                </span>
              </div>
              <div>
                <span className="normal_text fw-500">
                  {data.item?.formatted?.ServiceType}
                </span>
              </div>
            </div>
            <div className="propertyCardQuantity">
              <div className="d-flex align-items-center gap-1">
                <img src={GetImages.OrangeCalendar} className="iconstyle14" />
                <span className="sub_text black">
                  Created on:{" "}
                  {DateHelper.convertUTCtoDateTime(data.item?.requestDate)}
                </span>
              </div>
              {data.item?.assignedTo ? (
                <div className="d-flex align-items-center gap-1">
                  <img src={GetImages.OrangeUser} className="iconstyle18" />
                  <span className="sub_text black">
                    Contractor: {data.item?.assignedTo}
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="middleBoxDetails">
          {data?.isAddress &&
            <>
              <p className="sub_text d-flex align-items-center gap-2">
                {data?.item?.unitNumber ? (
                  <>
                    <p className="sub_text">{data.item.unitNumber}</p>
                    <div className="dashLine"></div>
                  </>
                ) : null}
              </p>

              <p className="sub_text black">
                {data?.item?.streetAddress?.trim() == "" ? "N/A" : data?.item?.streetAddress}
              </p>
            </>
          }
        </div>

        <div style={{ width: "30%" }} className="propertCardRight">
          {data.item?.formatted?.ServiceRequestStatus === "In Progress" && (
            <StatusTag
              color={"yellow"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Payment Pending" && (
            <StatusTag
              color={"red"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Completed" && (
            <StatusTag
              color={"green"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Open" && (
            <StatusTag
              color={"yellow"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}

          {data.item?.formatted?.ServiceRequestStatus === "New Request" && (
            <StatusTag
              color={"lightBlue"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Estimating" && (
            <StatusTag
              color={"lightBlue"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}
          {data.item?.formatted?.ServiceRequestStatus === "Verification Pending" && (
            <StatusTag
              color={"blue"}
              statusText={data.item?.formatted?.ServiceRequestStatus}
            />
          )}

          {data.item?.formatted?.ServiceRequestStatus === "In Progress" && (
            <AddTraspButton bname ="View Details" border={true}/>
          )}
          {data.item?.formatted?.ServiceRequestStatus === "Payment Pending" && (
            <AddTraspButton bname = {`Pay $ ${data.item.formatted.TotalCost}`} border={true}/>
          )}

          {data.item?.formatted?.ServiceRequestStatus === "New Request" && (
             <AddTraspButton bname ="Assign Contractor" border={true}/>
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Completed" && (
             <AddTraspButton bname ="View Details" border={true}/>
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Open" && (
            <AddTraspButton bname ="View Details" border={true}/>
          )}

          {data.item?.formatted?.ServiceRequestStatus === "Estimating" && (
           <AddTraspButton bname ="View Details" border={true}/>
          )}
          {data.item?.formatted?.ServiceRequestStatus === "Verification Pending" && (
             <AddTraspButton bname ="View Details" border={true}/>
          )}
        </div>
      </div>
    </>
  );
};

export default CardView;
